import { useNavigate } from 'react-router-dom';
import { useAnalytics, useSteps } from '~/hooks';
import { Button } from '../Button';
import { LoadingSpinnerIcon } from '../Icons';
import { NavigationButtonGroup } from './styles';

interface NavigationButtonProps {
    backPath?: string;
    formId?: string;
    isDisabled?: boolean;
    isSubmitting?: boolean;
}

export const NavigationButtons = ({ formId, isSubmitting, isDisabled, backPath }: NavigationButtonProps) => {
    const navigate = useNavigate();
    const { currentPath, previousPath } = useSteps();
    const { pushEvent } = useAnalytics();

    const handleBack = () => {
        navigate(backPath ?? previousPath);
        pushEvent({ eventLabel: 'Back' });
    };

    return (
        <NavigationButtonGroup>
            {formId && !isDisabled && (
                <Button
                    onClick={() => pushEvent({ eventLabel: 'Next' })}
                    buttonVariant="primary"
                    type="submit"
                    form={formId}
                >
                    {isSubmitting ? <LoadingSpinnerIcon /> : 'Next'}
                </Button>
            )}
            {currentPath !== '/' && <Button onClick={handleBack}>Back</Button>}
        </NavigationButtonGroup>
    );
};
